/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { Outlet } from "react-router-dom";
import { BreadcrumbList } from "cms/shared/breadcrumb";
import { Footer } from "layout-components/footer";
import { Header } from "layout-components/header";
import { EnvWrapper } from "cms/auth/components/env-wrapper";

const ApplicationLayout = (props) => {

    const { crumbs } = props;

    return (
        <>
            <EnvWrapper>
                <Header />

                {/* Child routes are rendered here */}
                <div tabIndex={-1} id="skip-content-start" className="application layout layout-fullwidth">

                    <BreadcrumbList crumbs={crumbs}/>

                    <Outlet />

                </div>

                <Footer />
            </EnvWrapper>
        </>
    );
};
export { ApplicationLayout };
